import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Handshake, Folder, PaperPlaneTilt, CheckCircle } from '@phosphor-icons/react';
import { getWelcomeTourStatus, completeWelcomeTour } from '../services/api';

const STEPS = [
  {
    icon: Handshake,
    title: 'Bienvenue dans votre espace coopérateur',
    body: "Votre adhésion est validée. Retrouvez ici vos missions, conventions, publications et reçus au même endroit.",
  },
  {
    icon: Folder,
    title: 'Vos documents à portée de main',
    body: "Dans « Mes conventions » et « Documents », consultez et signez vos contrats en ligne. Votre reçu de contribution est également disponible.",
  },
  {
    icon: PaperPlaneTilt,
    title: 'Restez informé·e',
    body: "L'onglet « Publications » vous montre les annonces qui vous concernent : missions à réserver, événements, offres partenaires.",
  },
];

export default function WelcomeTourModal() {
  const [show, setShow] = useState(false);
  const [step, setStep] = useState(0);
  const [name, setName] = useState('');

  useEffect(() => {
    getWelcomeTourStatus().then((r) => {
      if (r.data.should_show) { setShow(true); setName(r.data.user_name || ''); }
    }).catch(() => {});
  }, []);

  const finish = async () => {
    try { await completeWelcomeTour(); }
    catch { toast.error('Erreur'); return; }
    setShow(false);
  };

  if (!show) return null;
  const Step = STEPS[step];
  const Icon = Step.icon;
  const isLast = step === STEPS.length - 1;

  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent className="max-w-md" data-testid="welcome-tour-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Icon size={22} className="text-[#2D5A4C]" /> {Step.title}
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-[#5E6D66]">{name && step === 0 ? `Bonjour ${name}, ` : ''}{Step.body}</p>
        <div className="flex justify-center gap-2 my-2">
          {STEPS.map((_, i) => (
            <span key={i} className={`w-2 h-2 rounded-full ${i === step ? 'bg-[#2D5A4C]' : 'bg-[#E8E6E1]'}`} />
          ))}
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={finish} data-testid="welcome-tour-skip">Passer</Button>
          {isLast ? (
            <Button onClick={finish} className="bg-[#2D5A4C] hover:bg-[#1E4136]" data-testid="welcome-tour-done">
              <CheckCircle size={14} className="mr-1" /> Commencer
            </Button>
          ) : (
            <Button onClick={() => setStep(step + 1)} className="bg-[#2D5A4C] hover:bg-[#1E4136]" data-testid="welcome-tour-next">Suivant</Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
